const homePlaylistPath = '/home/playlist'
const homeStudentAssignmentsPath = '/home/assignments'
const studentSebQuitConfirmpath = '/student/seb-quit-confirm'
const homeStudentGradesPath = '/home/grades'

const toolMap = {
  CROSS_OUT: 3,
}

const magnifierSizes = {
  SMALL: 'small',
  MEDIUM: 'medium',
}

const PAUSE_REASONS = {
  BLOCK_EXTENSION: 'block-extension',
}

const PAUSE_REASON_EXPLAIN_MESSAGE = {
  BLOCK_EXTENSION:
    'Test is paused due to unauthorized browser extension. To reopen, check the box on this student’s card, click on More, and select Resume',
}

const PAUSE_MESSAGES = {
  SECURITY_REASON:
    'Your test has been locked for security reasons. Please contact your teacher to reopen your test',
}

export {
  homePlaylistPath,
  homeStudentAssignmentsPath,
  studentSebQuitConfirmpath,
  homeStudentGradesPath,
  toolMap,
  magnifierSizes,
  PAUSE_REASONS,
  PAUSE_MESSAGES,
  PAUSE_REASON_EXPLAIN_MESSAGE,
}
